import React from 'react';
import ReactDOM from 'react-dom';
import {Link} from 'react-router';
import General from '../../modules/General';

export default class Nav extends React.Component {
	constructor(props) {
		super(props);


	}

	handleSave(e) {
		e.stopPropagation();
		this.props.save();
	}

	getLinkType() {
		if(!this.props.backLink) {
			return <Link to={(this.props.backLink ? this.props.backLink:'/dashboard')} className="btn btn-default">{(this.props.backText ? this.props.backText:'Back')}</Link>
		}

		if(this.props.backLink.includes("https://")) {
		    return <a href={this.props.backLink} className="btn btn-default">{(this.props.backText ? this.props.backText:'Back')}</a>
		}

		return <Link to={(this.props.backLink ? this.props.backLink:'/dashboard')} className="btn btn-default">{(this.props.backText ? this.props.backText:'Back')}</Link>
	}

	render() {	
		return (
			<nav className="site-navbar navbar navbar-default navbar-fixed-top navbar-mega builder" role="navigation">
				<div className="navbar-header">
					<div className="p-15" data-toggle="gridmenu">
						{this.getLinkType()}
					</div>
				</div>

				<div className="navbar-container container-fluid">
					<div className="collapse navbar-collapse navbar-collapse-toolbar" id="site-navbar-collapse">
						<ul className="nav navbar-toolbar navbar-right navbar-toolbar-right">
						{this.props.children}
						</ul>
					</div>
				</div>

				
			</nav>
		);
	}
}




// WEBPACK FOOTER //
// ./containers/builder/Nav.js